import React, { FC, memo } from 'react'

import { rules } from 'modules/ProjectEdit/constants'
import { FormInput, FormSelect } from 'components/FormWithGroup'
import { OwnerField } from './OwnerField'
import { ArtistAutocomplete } from './ArtistAutocomplite'

import { IProjectDetailFormProps } from 'modules/ProjectEdit/components/ProjectDetailForm/ProjectDetailForm.props'

import styles from './ProjectDetailForm.module.scss'

export const ProjectDetailForm: FC<IProjectDetailFormProps> = memo(({ artist, gpsUnits, unitOptions, control }) => (
  <>
    <section className={styles.section}>
      <FormInput label="Project" control={control} fieldName="name" rules={rules.projectName} />
      <FormSelect label="Unit" control={control} fieldName="unitId" options={unitOptions} rules={rules.unit} />
      <OwnerField />
    </section>
    <section className={styles.section}>
      <FormInput
        className="project-details__field--opus"
        label="OPUS-ID"
        control={control}
        fieldName="opusId"
        disabled
      />
      <FormSelect
        label="GPS Artist Status"
        control={control}
        fieldName="gpsStatus"
        options={gpsUnits}
        isClearable
      />
      <ArtistAutocomplete artist={artist} control={control}/>
    </section>
  </>
))
